var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1895",
    "data-name": "Group 1895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_610",
    "data-name": "Ellipse 610"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,94.88C26.7,94.88,7.73,74.75,7.73,50S26.7,5.1,50,5.1,92.27,25.24,92.27,50,73.31,94.88,50,94.88ZM50,11.1C30,11.1,13.73,28.55,13.73,50S30,88.88,50,88.88,86.27,71.44,86.27,50,70,11.1,50,11.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_926",
    "data-name": "Path 926"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.7,53H50a3,3,0,0,1-3-3V26.39a3,3,0,0,1,6,0V47H70.7a3,3,0,0,1,0,6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.d7792638d78a22856ef4680bbdcba723.svg";
export { ForwardRef as ReactComponent };